export const apartmentCategoryMapper = (data) => ({
    id: data.id,
    name: data.name,
})